'use strict';

var ResizableDirective = function ResizableDirective(Resizable) {
  return {
    restrict: 'A',
    scope: {
      resizableOptions: '=?'
    },
    link: function link(scope, element) {
      scope.resize = function (event) {
        element.width(event.rect.width);
      };
      var resize = new Resizable(element.context, scope.resizableOptions);
      resize.getInteractor().on('resizemove', scope.resize);
    }
  };
};
ResizableDirective.$inject = ['ResizableFactory'];
module.exports = ResizableDirective;